import {
    ProSkillManagerAssessmentDetailInfoModel
} from '~~/package/mapper/proSkillManager/model/assessment/ProSkillManagerAssessmentDetailInfoModel';
import {PageModel} from '~~/package/mapper/common/model/PageModel';
import {
    ProSkillManagerCandidateModel
} from '~~/package/mapper/proSkillManager/model/candidate/ProSkillManagerCandidateModel';
import {
    ProSkillAssureMyAssessmentModel
} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureMyAssessmentModel';
import {ProSkillManagerType} from '~~/package/mapper/proSkillManager/model/ProSkillManagerType';
import { ViolationGradeType } from '~~/package/mapper/report/model/ViolationGradeType';

export const monitorSampleUUID = [
    'e9134e9d-d983-4933-9fdc-ee2141699648',
    'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
    'a1b2c3d4-e5f6-7890-abcd-ef1234567890'
];
export const monitorManageAssessmentData = {
    assessment: {
        'id': 0,
        'title': 'Sample Assessment',
        'questionCount': 15,
        'totalTime': 18000,
        'isNoTimeLimit': false,
        'startedAt': '2026-01-01 00:00:00',
        'endedAt': '2030-12-31 00:00:00',
        'assessmentStatus': 'LIVE',
        'processStatus': 'IN_PROGRESS',
        'candidateStats': {
            'preStart': 1,
            'started': 0,
            'completed': 2
        }
    } as ProSkillAssureMyAssessmentModel
};
export const monitorAssessmentDetailPage = {
    info: {
        'status': 'LIVE',
        'title': 'Sample Assessment',
        'startedAt': '2026-01-01 00:00:00',
        'endedAt': '2030-12-31 00:00:00',
        duration: 10800
    } as ProSkillManagerAssessmentDetailInfoModel,
    candidateData: {
        'data': [
            {
                'name': 'Gildong Hong 2',
                'email': 'sample2@codepresso.kr',
                'userStatus': 'NORMAL',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'userUUID': 'e9134e9d-d983-4933-9fdc-ee2141699648',
                'userId': 10795,
                'isScoreExposure': true,
                'isReportExposure': false,
                'reportUrl': null,
                'overallInfo': {
                    'assessmentName': 'Sample Assessment',
                    'assessmentId': 0,
                    'assessmentStatus': 'LIVE',
                    'lastRecord': '2026-02-01 03:20:28.784876',
                    'integrityGrade': ViolationGradeType.CLEAN,
                    'integrityReason': null,
                    'status': 'COMPLETED',
                    'assessmentType': 'EXTERNAL',
                    'currentRank': 2,
                    'totalRank': 3,
                    'currentOverallScore': 58.5,
                    'totalOverallScore': 100,
                    'timeTaken': 8021,
                    'totalTimeTaken': 10800,
                    'skillAcquisitionRate': 56.1,
                    'skillAcquisitionRateRank': 2,
                    'totalSkillAcquisitionRateRank': 3
                },
                'trackResults': [
                    {
                        'trackId': 572,
                        'testTemplateId': 0,
                        'trackName': 'Prompt Engineering for Developers',
                        'currentTrackRank': 2,
                        'totalTrackRank': 3,
                        'currentTrackScore': 60.0,
                        'timeTaken': 3144,
                        'skillAcquisitionRate': 65.0,
                        'skillAcquisitionRateRank': 2,
                        'totalSkillAcquisitionRateRank': 3,
                        'trackLevelName': 'Beginner',
                        'trackLevelId': 874
                    },
                    {
                        'trackId': 200001,
                        'testTemplateId': 1,
                        'trackName': 'JavaScript',
                        'currentTrackRank': 2,
                        'totalTrackRank': 3,
                        'currentTrackScore': 57.0,
                        'timeTaken': 4877,
                        'skillAcquisitionRate': 51.1,
                        'skillAcquisitionRateRank': 2,
                        'totalSkillAcquisitionRateRank': 3,
                        'trackLevelName': 'Intermediate',
                        'trackLevelId': 82
                    }
                ]
            },
            {
                'name': 'Gildong Hong 1',
                'email': 'sample@codepresso.kr',
                'userStatus': 'NORMAL',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'userUUID': 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                'userId': 10794,
                'isScoreExposure': true,
                'isReportExposure': true,
                'reportUrl': null,
                'overallInfo': {
                    'assessmentName': 'Sample Assessment',
                    'assessmentId': 0,
                    'assessmentStatus': 'LIVE',
                    'lastRecord': '2026-01-31 03:22:57.704502',
                    'integrityGrade': ViolationGradeType.CLEAN,
                    'integrityReason': null,
                    'status': 'COMPLETED',
                    'assessmentType': 'EXTERNAL',
                    'currentRank': 1,
                    'totalRank': 3,
                    'currentOverallScore': 88.5,
                    'totalOverallScore': 100,
                    'timeTaken': 6232,
                    'totalTimeTaken': 10800,
                    'skillAcquisitionRate': 87.8,
                    'skillAcquisitionRateRank': 1,
                    'totalSkillAcquisitionRateRank': 3
                },
                'trackResults': [
                    {
                        'trackId': 572,
                        'testTemplateId': 0,
                        'trackName': 'Prompt Engineering for Developers',
                        'currentTrackRank': 1,
                        'totalTrackRank': 3,
                        'currentTrackScore': 83.0,
                        'timeTaken': 2887,
                        'skillAcquisitionRate': 85.5,
                        'skillAcquisitionRateRank': 1,
                        'totalSkillAcquisitionRateRank': 3,
                        'trackLevelName': 'Beginner',
                        'trackLevelId': 874
                    },
                    {
                        'trackId': 200001,
                        'testTemplateId': 1,
                        'trackName': 'JavaScript',
                        'currentTrackRank': 1,
                        'totalTrackRank': 3,
                        'currentTrackScore': 94.0,
                        'timeTaken': 3345,
                        'skillAcquisitionRate': 89.1,
                        'skillAcquisitionRateRank': 1,
                        'totalSkillAcquisitionRateRank': 3,
                        'trackLevelName': 'Intermediate',
                        'trackLevelId': 82
                    }
                ]
            },
            {
                'name': 'Gildong Hong 3',
                'email': 'sample3@codepresso.kr',
                'userStatus': 'NORMAL',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'userUUID': 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
                'userId': 10796,
                'isScoreExposure': false,
                'isReportExposure': false,
                'reportUrl': null,
                'overallInfo': {
                    'assessmentName': 'Sample Assessment',
                    'assessmentId': 0,
                    'assessmentStatus': 'LIVE',
                    'lastRecord': null,
                    'integrityGrade': null,
                    'integrityReason': null,
                    'status': 'READY',
                    'assessmentType': 'EXTERNAL',
                    'currentRank': null,
                    'totalRank': 3,
                    'currentOverallScore': null,
                    'totalOverallScore': 100,
                    'timeTaken': null,
                    'totalTimeTaken': 10800,
                    'skillAcquisitionRate': null,
                    'skillAcquisitionRateRank': null,
                    'totalSkillAcquisitionRateRank': 3
                },
                'trackResults': [
                    {
                        'trackId': 572,
                        'testTemplateId': 0,
                        'trackName': 'Prompt Engineering for Developers',
                        'currentTrackRank': null,
                        'totalTrackRank': 3,
                        'currentTrackScore': null,
                        'timeTaken': 0,
                        'skillAcquisitionRate': null,
                        'skillAcquisitionRateRank': null,
                        'totalSkillAcquisitionRateRank': 3,
                        'trackLevelName': 'Beginner',
                        'trackLevelId': 874
                    },
                    {
                        'trackId': 200001,
                        'testTemplateId': 1,
                        'trackName': 'JavaScript',
                        'currentTrackRank': null,
                        'totalTrackRank': 3,
                        'currentTrackScore': null,
                        'timeTaken': 0,
                        'skillAcquisitionRate': null,
                        'skillAcquisitionRateRank': null,
                        'totalSkillAcquisitionRateRank': 3,
                        'trackLevelName': 'Intermediate',
                        'trackLevelId': 82
                    }
                ]
            }
        ],
        'pageNumber': 1,
        'last': true,
        'totalElementCount': 3,
        'sort': {
            'empty': false,
            'sorted': true,
            'unsorted': false
        }
    } as unknown as PageModel<ProSkillManagerCandidateModel>,
    history: {
        'e9134e9d-d983-4933-9fdc-ee2141699648': {
            'userInfo': {
                'nickName': 'Gildong Hong 2',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample2@codepresso.kr'
            },
            'statusHistoryVOList': [
                {
                    'status': 'COMPLETED',
                    'statusAt': '2026-01-31 06:12',
                    'userMapCustomAssessmentHistoryId': 4221
                },
                {
                    'status': 'IN_PROGRESS',
                    'statusAt': '2026-01-31 06:07',
                    'userMapCustomAssessmentHistoryId': 4220
                },
                {
                    'status': 'READY',
                    'statusAt': '2026-01-31 06:07',
                    'userMapCustomAssessmentHistoryId': 4219
                },
                {
                    'status': 'INVITED',
                    'statusAt': '2026-01-31 06:07',
                    'userMapCustomAssessmentHistoryId': 4218
                }
            ],
            'isSampleData': true
        },
        'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0': {
            'userInfo': {
                'nickName': 'Gildong Hong 1',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample@codepresso.kr'
            },
            'statusHistoryVOList': [
                {
                    'status': 'COMPLETED',
                    'statusAt': '2026-01-31 01:21',
                    'userMapCustomAssessmentHistoryId': 4180
                },
                {
                    'status': 'IN_PROGRESS',
                    'statusAt': '2026-01-31 01:01',
                    'userMapCustomAssessmentHistoryId': 4179
                },
                {
                    'status': 'READY',
                    'statusAt': '2026-01-31 01:01',
                    'userMapCustomAssessmentHistoryId': 4178
                },
                {
                    'status': 'INVITED',
                    'statusAt': '2026-01-31 01:00',
                    'userMapCustomAssessmentHistoryId': 4177
                }
            ],
            'isSampleData': true
        },
        'a1b2c3d4-e5f6-7890-abcd-ef1234567890': {
            'userInfo': {
                'nickName': 'Gildong Hong 3',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample3@codepresso.kr'
            },
            'statusHistoryVOList': [
                {
                    'status': 'READY',
                    'statusAt': '2026-02-02 01:30',
                    'userMapCustomAssessmentHistoryId': 4298
                },
                {
                    'status': 'INVITED',
                    'statusAt': '2026-02-02 01:30',
                    'userMapCustomAssessmentHistoryId': 4297
                }
            ],
            'isSampleData': true
        }
    },
    action: {
        'e9134e9d-d983-4933-9fdc-ee2141699648': {
            'userInfo': {
                'nickName': 'Gildong Hong 2',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample2@codepresso.kr'
            },
            'actions': [],
            'isSampleData': true
        },
        'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0': {
            'userInfo': {
                'nickName': 'Gildong Hong 1',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample@codepresso.kr'
            },
            'actions': [],
            'isSampleData': true
        },
        'a1b2c3d4-e5f6-7890-abcd-ef1234567890': {
            'userInfo': {
                'nickName': 'Gildong Hong 3',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample3@codepresso.kr'
            },
            'actions': [],
            'isSampleData': true
        }
    }
};
export const monitorSampleReportData = {
    'e9134e9d-d983-4933-9fdc-ee2141699648': {
        'title': 'Sample Assessment',
        'endedAt': '2026-02-01 03:20:28.784876',
        'rank': 2,
        'score': 58.5,
        'timeTaken': 8021,
        'actionCount': 0,
        'userInfo': {
            'nickName': 'Gildong Hong 2',
            'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
            'email': 'sample2@codepresso.kr'
        },
        'assessmentCandidatesSet': [
            {
                'trackId': 572,
                'testTemplateId': 0,
                'trackTitle': 'Prompt Engineering for Developers',
                'trackLevelTitle': 'Beginner',
                'status': 'PASSED',
                'rank': 2,
                'score': 60.0
            },
            {
                'trackId': 200001,
                'testTemplateId': 1,
                'trackTitle': 'JavaScript',
                'trackLevelTitle': 'Intermediate',
                'status': 'PASSED',
                'rank': 2,
                'score': 57.0
            }
        ]
    },
    'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0': {
        'title': 'Sample Assessment',
        'endedAt': '2026-01-31 03:22:57.701556',
        'rank': 1,
        'score': 89,
        'timeTaken': 6240,
        'actionCount': 58,
        'userInfo': {
            'nickName': 'Gildong Hong 1',
            'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
            'email': 'sample@codepresso.kr',
            'userStatus': 'NORMAL'
        },
        'assessmentCandidatesSet': [
            {
                'trackId': 572,
                'testTemplateId': 0,
                'trackTitle': 'Prompt Engineering for Developers',
                'trackLevelTitle': 'Beginner',
                'status': 'PASSED',
                'rank': 1,
                'score': 83
            },
            {
                'trackId': 200001,
                'testTemplateId': 1,
                'trackTitle': 'JavaScript',
                'trackLevelTitle': 'Intermediate',
                'status': 'PASSED',
                'rank': 1,
                'score': 94
            }
        ]
    }
};

export const monitorSampleAssessmentTasks: Array<{ trackTitle: string; trackLevelTitle: string; taskIds: number[] }> = [
    {
        trackTitle: 'Prompt Engineering for Developers',
        trackLevelTitle: 'Beginner',
        taskIds: [410737, 410739, 410741, 410778]
    },
    {
        trackTitle: 'JavaScript',
        trackLevelTitle: 'Intermediate',
        taskIds: [409293]
    }
];

export const monitorSampleSubmissionData = {
    'e9134e9d-d983-4933-9fdc-ee2141699648': {
        '0': {
            'title': 'Sample Assessment',
            'order': 1,
            'trackId': 572,
            'trackTitle': 'Prompt Engineering for Developers',
            'trackLevelTitle': 'Beginner',
            'userInfo': {
                'nickName': 'Gildong Hong 2',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample2@codepresso.kr'
            },
            'assessmentResults': [
                {
                    'taskId': 400930,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '1'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5290,
                        'taskId': 400930,
                        'answer': [
                            1
                        ],
                        'question': 'Which of the following best describes the meaning of the HTTP status code 201?',
                        'multipleChoiceQuestion': [
                            'OK',
                            'Created',
                            'Accepted',
                            'No Content'
                        ]
                    }
                },
                {
                    'taskId': 400931,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '1'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5282,
                        'taskId': 400931,
                        'answer': [
                            1
                        ],
                        'question': 'Select the main reason why constructor injection is recommended in Spring.',
                        'multipleChoiceQuestion': [
                            'Code simplicity',
                            'Prevention of circular dependencies',
                            'Performance improvement',
                            'Reduction in the amount of XML configuration files to write'
                        ]
                    }
                },
                {
                    'taskId': 400932,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '2',
                        '3'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5284,
                        'taskId': 400932,
                        'answer': [
                            2,
                            3
                        ],
                        'question': 'In Spring, which annotation is used to define a Bean at the class level?',
                        'multipleChoiceQuestion': [
                            '@Autowired',
                            '@Qualifier',
                            '@Component',
                            '@Configuration'
                        ]
                    }
                },
                {
                    'taskId': 400933,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '1'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5289,
                        'taskId': 400933,
                        'answer': [
                            1
                        ],
                        'question': 'Select the incorrect statement about Spring Dependency Injection(DI).',
                        'multipleChoiceQuestion': [
                            'DI stands for Dependency Injection, which means that the Spring container injects dependencies between objects.',
                            'DI induces strong coupling between objects, increasing code reusability.',
                            'In Spring, annotations such as @Autowired, @Inject, and @Resource can be used to implement DI.',
                            'DI generally helps make application testing easier and maintenance more straightforward.'
                        ]
                    }
                },
                {
                    'taskId': 400934,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '2'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5285,
                        'taskId': 400934,
                        'answer': [
                            2
                        ],
                        'question': 'In a RESTful web service, which HTTP method is used to modify a resource and ensures idempotency?',
                        'multipleChoiceQuestion': [
                            'GET',
                            'POST',
                            'PUT',
                            'PATCH'
                        ]
                    }
                },
                {
                    'taskId': 400935,
                    'isSubmission': true,
                    'resultStatus': 'IN_CORRECT',
                    'level': 3,
                    'type': 'MULTI_FILE_CODE',
                    'langType': 'SPRINGBOOT',
                    'selfCodingAnswer': '',
                    'submissionAnswer': [
                        ''
                    ],
                    'question': ''
                }
            ]
        },
        '1': {
            'title': 'Sample Assessment',
            'order': 2,
            'trackId': 200001,
            'trackTitle': 'JavaScript',
            'trackLevelTitle': 'Intermediate',
            'userInfo': {
                'nickName': 'Gildong Hong 2',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample2@codepresso.kr'
            },
            'assessmentResults': [
                {
                    'taskId': 409293,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 2,
                    'type': 'MULTI_FILE_CODE',
                    'langType': 'HTML_CSS_JAVASCRIPT',
                    'selfCodingAnswer': '',
                    'submissionAnswer': [
                        ''
                    ],
                    'question': ''
                }
            ]
        },
        '3': {
            'title': 'Sample Assessment',
            'order': 3,
            'trackId': 6,
            'trackTitle': 'Python',
            'trackLevelTitle': 'Intermediate',
            'userInfo': {
                'nickName': 'Gildong Hong 2',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample2@codepresso.kr'
            },
            'assessmentResults': [
                {
                    'taskId': 400784,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'CODE',
                    'langType': 'PYTHON',
                    'selfCodingAnswer': 'input_string = "codepresso"\n' +
                        '\n' +
                        'def get_reversed_string(input_string):\n' +
                        '   string_length = len(input_string)\n' +
                        '   reversed_string = ""\n' +
                        '   for i in range(string_length - 1, -1, -1):\n' +
                        '      reversed_string += input_string[i]\n' +
                        '   return reversed_string\n' +
                        '\n' +
                        'print("Print reversed string :", get_reversed_string(input_string))',
                    'submissionAnswer': [
                        'input_string = "codepresso"\n' +
                        '\n' +
                        'def get_reversed_string(input_string):\n' +
                        '   string_length = len(input_string)\n' +
                        '   reversed_string = ""\n' +
                        '   for i in range(string_length - 1, -1, -1):\n' +
                        '      reversed_string += input_string[i]\n' +
                        '   return reversed_string\n' +
                        '\n' +
                        'print("Print reversed string :", get_reversed_string(input_string))'
                    ],
                    'question': ''
                },
                {
                    'taskId': 400783,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 2,
                    'type': 'CODE',
                    'langType': 'PYTHON',
                    'selfCodingAnswer': '# Initialize the book system dictionary\n' +
                        'book_system = {"Fiction": 0, "Non-Fiction": 0, "Science Fiction": 0, "Children\'s Books": 0}\n' +
                        '\n' +
                        'def add_books_to_genre(book_system, genre, num_books):\n' +
                        '    if genre in book_system:\n' +
                        '        book_system[genre] += num_books\n' +
                        '    else:        \n' +
                        '        book_system[genre] = num_books\n' +
                        '\n' +
                        'def print_books_counts():\n' +
                        '  for genre, count in book_system.items():\n' +
                        '    print(f"{genre}: {count}")\n' +
                        '\n' +
                        '# Testing the system\n' +
                        'add_books_to_genre(book_system, "Fiction", 7)\n' +
                        'add_books_to_genre(book_system, "Cookbooks", 8)\n' +
                        'add_books_to_genre(book_system, "Non-Fiction", 3)\n' +
                        'add_books_to_genre(book_system, "Travel", 2)\n' +
                        '\n' +
                        '# Display the updated counts\n' +
                        'print_books_counts()\n',
                    'submissionAnswer': [
                        '# Initialize the book system dictionary\n' +
                        'book_system = {"Fiction": 0, "Non-Fiction": 0, "Science Fiction": 0, "Children\'s Books": 0}\n' +
                        '\n' +
                        'def add_books_to_genre(book_system, genre, num_books):\n' +
                        '    if genre in book_system:\n' +
                        '        book_system[genre] += num_books\n' +
                        '    else:        \n' +
                        '        book_system[genre] = num_books\n' +
                        '\n' +
                        'def print_books_counts():\n' +
                        '  for genre, count in book_system.items():\n' +
                        '    print(f"{genre}: {count}")\n' +
                        '\n' +
                        '# Testing the system\n' +
                        'add_books_to_genre(book_system, "Fiction", 7)\n' +
                        'add_books_to_genre(book_system, "Cookbooks", 8)\n' +
                        'add_books_to_genre(book_system, "Non-Fiction", 3)\n' +
                        'add_books_to_genre(book_system, "Travel", 2)\n' +
                        '\n' +
                        '# Display the updated counts\n' +
                        'print_books_counts()\n'
                    ],
                    'question': ''
                }
            ]
        }
    },
    'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0': {
        '0': {
            'title': 'Sample Assessment',
            'order': 1,
            'trackId': 572,
            'trackTitle': 'Prompt Engineering for Developers',
            'trackLevelTitle': 'Beginner',
            'userInfo': {
                'nickName': 'Gildong Hong 1',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample@codepresso.kr'
            },
            'assessmentResults': [
                {
                    'taskId': 400930,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '1'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5290,
                        'taskId': 400930,
                        'answer': [
                            1
                        ],
                        'question': 'Which of the following best describes the meaning of the HTTP status code 201?',
                        'multipleChoiceQuestion': [
                            'OK',
                            'Created',
                            'Accepted',
                            'No Content'
                        ]
                    }
                },
                {
                    'taskId': 400931,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '1'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5282,
                        'taskId': 400931,
                        'answer': [
                            1
                        ],
                        'question': 'Select the main reason why constructor injection is recommended in Spring.',
                        'multipleChoiceQuestion': [
                            'Code simplicity',
                            'Prevention of circular dependencies',
                            'Performance improvement',
                            'Reduction in the amount of XML configuration files to write'
                        ]
                    }
                },
                {
                    'taskId': 400932,
                    'isSubmission': true,
                    'resultStatus': 'IN_CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '1',
                        '3'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5284,
                        'taskId': 400932,
                        'answer': [
                            2,
                            3
                        ],
                        'question': 'In Spring, which annotation is used to define a Bean at the class level?',
                        'multipleChoiceQuestion': [
                            '@Autowired',
                            '@Qualifier',
                            '@Component',
                            '@Configuration'
                        ]
                    }
                },
                {
                    'taskId': 400933,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '1'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5289,
                        'taskId': 400933,
                        'answer': [
                            1
                        ],
                        'question': 'Select the incorrect statement about Spring Dependency Injection(DI).',
                        'multipleChoiceQuestion': [
                            'DI stands for Dependency Injection, which means that the Spring container injects dependencies between objects.',
                            'DI induces strong coupling between objects, increasing code reusability.',
                            'In Spring, annotations such as @Autowired, @Inject, and @Resource can be used to implement DI.',
                            'DI generally helps make application testing easier and maintenance more straightforward.'
                        ]
                    }
                },
                {
                    'taskId': 400934,
                    'isSubmission': true,
                    'resultStatus': 'IN_CORRECT',
                    'level': 1,
                    'type': 'MULTIPLE_CHOICE',
                    'langType': 'SPRINGBOOT',
                    'submissionAnswer': [
                        '2',
                        '1'
                    ],
                    'multipleChoiceQuestion': {
                        'id': 5285,
                        'taskId': 400934,
                        'answer': [
                            2
                        ],
                        'question': 'In a RESTful web service, which HTTP method is used to modify a resource and ensures idempotency?',
                        'multipleChoiceQuestion': [
                            'GET',
                            'POST',
                            'PUT',
                            'PATCH'
                        ]
                    }
                },
                {
                    'taskId': 410737,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 3,
                    'type': 'MULTI_FILE_CODE',
                    'langType': 'SPRINGBOOT',
                    'selfCodingAnswer': '',
                    'submissionAnswer': [
                        ''
                    ],
                    'question': ''
                }
            ]
        },
        '1': {
            'title': 'Sample Assessment',
            'order': 2,
            'trackId': 200001,
            'trackTitle': 'JavaScript',
            'trackLevelTitle': 'Intermediate',
            'userInfo': {
                'nickName': 'Gildong Hong 1',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample@codepresso.kr'
            },
            'assessmentResults': [
                {
                    'taskId': 409293,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 2,
                    'type': 'MULTI_FILE_CODE',
                    'langType': 'HTML_CSS_JAVASCRIPT',
                    'selfCodingAnswer': '',
                    'submissionAnswer': [
                        ''
                    ],
                    'question': ''
                }
            ]
        },
        '3': {
            'title': 'Sample Assessment',
            'order': 3,
            'trackId': 6,
            'trackTitle': 'Python',
            'trackLevelTitle': 'Intermediate',
            'userInfo': {
                'nickName': 'Gildong Hong 1',
                'profileImageUrl': 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                'email': 'sample@codepresso.kr'
            },
            'assessmentResults': [
                {
                    'taskId': 400784,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 1,
                    'type': 'CODE',
                    'langType': 'PYTHON',
                    'selfCodingAnswer': 'input_string = "codepresso"\n' +
                        '\n' +
                        'def get_reversed_string(input_string):\n' +
                        '   string_length = len(input_string)\n' +
                        '   reversed_string = ""\n' +
                        '   for i in range(string_length - 1, -1, -1):\n' +
                        '      reversed_string += input_string[i]\n' +
                        '   return reversed_string\n' +
                        '\n' +
                        'print("Print reversed string :", get_reversed_string(input_string))',
                    'submissionAnswer': [
                        'input_string = "codepresso"\n' +
                        '\n' +
                        'def get_reversed_string(input_string):\n' +
                        '   string_length = len(input_string)\n' +
                        '   reversed_string = ""\n' +
                        '   for i in range(string_length - 1, -1, -1):\n' +
                        '      reversed_string += input_string[i]\n' +
                        '   return reversed_string\n' +
                        '\n' +
                        'print("Print reversed string :", get_reversed_string(input_string))'
                    ],
                    'question': ''
                },
                {
                    'taskId': 400783,
                    'isSubmission': true,
                    'resultStatus': 'CORRECT',
                    'level': 2,
                    'type': 'CODE',
                    'langType': 'PYTHON',
                    'selfCodingAnswer': '# Initialize the book system dictionary\n' +
                        'book_system = {"Fiction": 0, "Non-Fiction": 0, "Science Fiction": 0, "Children\'s Books": 0}\n' +
                        '\n' +
                        'def add_books_to_genre(book_system, genre, num_books):\n' +
                        '    if genre in book_system:\n' +
                        '        book_system[genre] += num_books\n' +
                        '    else:        \n' +
                        '        book_system[genre] = num_books\n' +
                        '\n' +
                        'def print_books_counts():\n' +
                        '  for genre, count in book_system.items():\n' +
                        '    print(f"{genre}: {count}")\n' +
                        '\n' +
                        '# Testing the system\n' +
                        'add_books_to_genre(book_system, "Fiction", 7)\n' +
                        'add_books_to_genre(book_system, "Cookbooks", 8)\n' +
                        'add_books_to_genre(book_system, "Non-Fiction", 3)\n' +
                        'add_books_to_genre(book_system, "Travel", 2)\n' +
                        '\n' +
                        '# Display the updated counts\n' +
                        'print_books_counts()\n',
                    'submissionAnswer': [
                        '# Initialize the book system dictionary\n' +
                        'book_system = {"Fiction": 0, "Non-Fiction": 0, "Science Fiction": 0, "Children\'s Books": 0}\n' +
                        '\n' +
                        'def add_books_to_genre(book_system, genre, num_books):\n' +
                        '    if genre in book_system:\n' +
                        '        book_system[genre] += num_books\n' +
                        '    else:        \n' +
                        '        book_system[genre] = num_books\n' +
                        '\n' +
                        'def print_books_counts():\n' +
                        '  for genre, count in book_system.items():\n' +
                        '    print(f"{genre}: {count}")\n' +
                        '\n' +
                        '# Testing the system\n' +
                        'add_books_to_genre(book_system, "Fiction", 7)\n' +
                        'add_books_to_genre(book_system, "Cookbooks", 8)\n' +
                        'add_books_to_genre(book_system, "Non-Fiction", 3)\n' +
                        'add_books_to_genre(book_system, "Travel", 2)\n' +
                        '\n' +
                        '# Display the updated counts\n' +
                        'print_books_counts()\n'
                    ],
                    'question': ''
                }
            ]
        }
    }
};
export const monitorSummaryData = {
    [ProSkillManagerType.ALL]: {
        assessmentsSummary: {
            total: 65,
            upcoming: 8,
            ended: 45,
            live: 12,
            stats: {
                average: 3.3833333333,
                slots: [
                    {timeslot: 'Mar, 2023', count: 1},
                    {timeslot: 'Apr, 2023', count: 3},
                    {timeslot: 'May, 2023', count: 5},
                    {timeslot: 'Jun, 2023', count: 4},
                    {timeslot: 'Jul, 2023', count: 3},
                    {timeslot: 'Aug, 2023', count: 7},
                    {timeslot: 'Sep, 2023', count: 4},
                    {timeslot: 'Oct, 2023', count: 6},
                    {timeslot: 'Nov, 2023', count: 2},
                    {timeslot: 'Dec, 2023', count: 1},
                    {timeslot: 'Jan, 2024', count: 3},
                    {timeslot: 'Feb, 2024', count: 2}
                ]
            }
        },
        candidatesSummary: {
            total: 596,
            preStart: 51,
            inProgress: 117,
            completed: 428,
            stats: {
                average: 598.083333333,
                slots: [
                    {timeslot: 'Mar, 2023', count: 12},
                    {timeslot: 'Apr, 2023', count: 33},
                    {timeslot: 'May, 2023', count: 45},
                    {timeslot: 'Jun, 2023', count: 50},
                    {timeslot: 'Jul, 2023', count: 35},
                    {timeslot: 'Aug, 2023', count: 80},
                    {timeslot: 'Sep, 2023', count: 26},
                    {timeslot: 'Oct, 2023', count: 60},
                    {timeslot: 'Nov, 2023', count: 19},
                    {timeslot: 'Dec, 2023', count: 8},
                    {timeslot: 'Jan, 2024', count: 35},
                    {timeslot: 'Feb, 2024', count: 24}
                ]
            }
        }
    },
    [ProSkillManagerType.INTERNAL]: {
        assessmentsSummary: {
            'total': 55,
            'upcoming': 5,
            'ended': 40,
            'live': 10,
            'stats': {
                'average': 3.3,
                'slots': [
                    {'timeslot': 'Mar, 2023', 'count': 1},
                    {'timeslot': 'Apr, 2023', 'count': 3},
                    {'timeslot': 'May, 2023', 'count': 5},
                    {'timeslot': 'Jun, 2023', 'count': 4},
                    {'timeslot': 'Jul, 2023', 'count': 3},
                    {'timeslot': 'Aug, 2023', 'count': 7},
                    {'timeslot': 'Sep, 2023', 'count': 3},
                    {'timeslot': 'Oct, 2023', 'count': 6},
                    {'timeslot': 'Nov, 2023', 'count': 2},
                    {'timeslot': 'Dec, 2023', 'count': 1},
                    {'timeslot': 'Jan, 2024', 'count': 3},
                    {'timeslot': 'Feb, 2024', 'count': 2}
                ]
            }
        },
        candidatesSummary: {
            'total': 589,
            'preStart': 48,
            'inProgress': 115,
            'completed': 426,
            'stats': {
                'average': 598,
                'slots': [
                    {'timeslot': 'Mar, 2023', 'count': 12},
                    {'timeslot': 'Apr, 2023', 'count': 33},
                    {'timeslot': 'May, 2023', 'count': 45},
                    {'timeslot': 'Jun, 2023', 'count': 50},
                    {'timeslot': 'Jul, 2023', 'count': 35},
                    {'timeslot': 'Aug, 2023', 'count': 80},
                    {'timeslot': 'Sep, 2023', 'count': 25},
                    {'timeslot': 'Oct, 2023', 'count': 60},
                    {'timeslot': 'Nov, 2023', 'count': 19},
                    {'timeslot': 'Dec, 2023', 'count': 8},
                    {'timeslot': 'Jan, 2024', 'count': 35},
                    {'timeslot': 'Feb, 2024', 'count': 24}
                ]
            }
        }
    },
    [ProSkillManagerType.EXTERNAL]: {
        'assessmentsSummary': {
            'total': 10,
            'upcoming': 3,
            'ended': 5,
            'live': 2,
            'stats': {
                'average': 0.08333333333333333,
                'slots': [
                    {'timeslot': 'Mar, 2023', 'count': 0},
                    {'timeslot': 'Apr, 2023', 'count': 0},
                    {'timeslot': 'May, 2023', 'count': 0},
                    {'timeslot': 'Jun, 2023', 'count': 0},
                    {'timeslot': 'Jul, 2023', 'count': 0},
                    {'timeslot': 'Aug, 2023', 'count': 0},
                    {'timeslot': 'Sep, 2023', 'count': 1},
                    {'timeslot': 'Oct, 2023', 'count': 0},
                    {'timeslot': 'Nov, 2023', 'count': 0},
                    {'timeslot': 'Dec, 2023', 'count': 0},
                    {'timeslot': 'Jan, 2024', 'count': 0},
                    {'timeslot': 'Feb, 2024', 'count': 0}
                ]
            }
        },
        'candidatesSummary': {
            'total': 7,
            'preStart': 3,
            'inProgress': 2,
            'completed': 2,
            'stats': {
                'average': 0.08333333333333333,
                'slots': [
                    {'timeslot': 'Mar, 2023', 'count': 0},
                    {'timeslot': 'Apr, 2023', 'count': 0},
                    {'timeslot': 'May, 2023', 'count': 0},
                    {'timeslot': 'Jun, 2023', 'count': 0},
                    {'timeslot': 'Jul, 2023', 'count': 0},
                    {'timeslot': 'Aug, 2023', 'count': 0},
                    {'timeslot': 'Sep, 2023', 'count': 1},
                    {'timeslot': 'Oct, 2023', 'count': 0},
                    {'timeslot': 'Nov, 2023', 'count': 0},
                    {'timeslot': 'Dec, 2023', 'count': 0},
                    {'timeslot': 'Jan, 2024', 'count': 0},
                    {'timeslot': 'Feb, 2024', 'count': 0}
                ]
            }
        }
    }
};
export const monitorDashboardSummaryData = {
    [ProSkillManagerType.ALL]: {
        assessmentSummary: {
            total: 65,
            upcoming: 8,
            ended: 45,
            live: 12
        },
        candidateSummary: {
            total: 596,
            preStart: 51,
            inProgress: 117,
            completed: 428
        }
    },
    [ProSkillManagerType.INTERNAL]: {
        assessmentSummary: {
            total: 55,
            upcoming: 5,
            ended: 40,
            live: 10
        },
        candidateSummary: {
            'total': 589,
            'preStart': 48,
            'inProgress': 115,
            'completed': 426
        }
    },
    [ProSkillManagerType.EXTERNAL]: {
        assessmentSummary: {
            'total': 10,
            'upcoming': 3,
            'ended': 5,
            'live': 2
        },
        candidateSummary: {
            'total': 7,
            'preStart': 3,
            'inProgress': 2,
            'completed': 2
        }
    }
};
export const monitorLevelTrackData = {
    [ProSkillManagerType.INTERNAL]: {
        'skillTracks': [
            {'type': 'SKILL', 'category': 'Linux Programming Track', 'level': 'Beginner', 'count': 24},
            {'type': 'SKILL', 'category': 'Linux Programming Track', 'level': 'Intermediate', 'count': 46},
            {'type': 'SKILL', 'category': 'Linux Programming Track', 'level': 'Professional', 'count': 5},
            {'type': 'SKILL', 'category': 'Java Script Programming Track', 'level': 'Beginner', 'count': 22},
            {'type': 'SKILL', 'category': 'Java Script Programming Track', 'level': 'Intermediate', 'count': 28},
            {'type': 'SKILL', 'category': 'Java Script Programming Track', 'level': 'Professional', 'count': 6},
            {'type': 'SKILL', 'category': 'SQL Programming Track', 'level': 'Beginner', 'count': 15},
            {'type': 'SKILL', 'category': 'SQL Programming Track', 'level': 'Intermediate', 'count': 44},
            {'type': 'SKILL', 'category': 'SQL Programming Track', 'level': 'Professional', 'count': 8},
            {'type': 'SKILL', 'category': 'Java Programming Track', 'level': 'Beginner', 'count': 42},
            {'type': 'SKILL', 'category': 'Java Programming Track', 'level': 'Intermediate', 'count': 27},
            {'type': 'SKILL', 'category': 'Java Programming Track', 'level': 'Professional', 'count': 3},
            {'type': 'SKILL', 'category': 'Python Programing Track', 'level': 'Beginner', 'count': 9},
            {'type': 'SKILL', 'category': 'Python Programing Track', 'level': 'Intermediate', 'count': 35},
            {'type': 'SKILL', 'category': 'Python Programing Track', 'level': 'Professional', 'count': 4}
        ],
        'careerTracks': [
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 1', 'count': 8},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 2', 'count': 26},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 3', 'count': 38},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 4', 'count': 34},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 5', 'count': 16},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 6', 'count': 40},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 7', 'count': 22},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 8', 'count': 10},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 9', 'count': 13},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 10', 'count': 10},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 1', 'count': 20},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 2', 'count': 15},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 3', 'count': 48},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 4', 'count': 9},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 5', 'count': 39},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 6', 'count': 28},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 7', 'count': 19},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 8', 'count': 5},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 9', 'count': 8},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 10', 'count': 5},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 1', 'count': 9},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 2', 'count': 9},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 3', 'count': 13},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 4', 'count': 14},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 5', 'count': 21},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 6', 'count': 37},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 7', 'count': 40},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 8', 'count': 4},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 9', 'count': 9},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 10', 'count': 10},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 1', 'count': 15},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 2', 'count': 30},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 3', 'count': 8},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 4', 'count': 32},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 5', 'count': 33},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 6', 'count': 35},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 7', 'count': 22},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 8', 'count': 22},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 9', 'count': 5},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 10', 'count': 1},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 1', 'count': 20},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 2', 'count': 25},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 3', 'count': 30},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 4', 'count': 40},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 5', 'count': 50},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 6', 'count': 5},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 7', 'count': 10},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 8', 'count': 5},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 9', 'count': 6},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 10', 'count': 3}
        ]
    },
    [ProSkillManagerType.EXTERNAL]: {
        'skillTracks': [
            {'type': 'SKILL', 'category': 'Linux Programming Track', 'level': 'Beginner', 'count': 24},
            {'type': 'SKILL', 'category': 'Linux Programming Track', 'level': 'Intermediate', 'count': 31},
            {'type': 'SKILL', 'category': 'Linux Programming Track', 'level': 'Professional', 'count': 8},
            {'type': 'SKILL', 'category': 'Java Script Programming Track', 'level': 'Beginner', 'count': 14},
            {'type': 'SKILL', 'category': 'Java Script Programming Track', 'level': 'Intermediate', 'count': 26},
            {'type': 'SKILL', 'category': 'Java Script Programming Track', 'level': 'Professional', 'count': 11},
            {'type': 'SKILL', 'category': 'SQL Programming Track', 'level': 'Beginner', 'count': 25},
            {'type': 'SKILL', 'category': 'SQL Programming Track', 'level': 'Intermediate', 'count': 21},
            {'type': 'SKILL', 'category': 'SQL Programming Track', 'level': 'Professional', 'count': 31},
            {'type': 'SKILL', 'category': 'Java Programming Track', 'level': 'Beginner', 'count': 4},
            {'type': 'SKILL', 'category': 'Java Programming Track', 'level': 'Intermediate', 'count': 38},
            {'type': 'SKILL', 'category': 'Java Programming Track', 'level': 'Professional', 'count': 25},
            {'type': 'SKILL', 'category': 'Python Programing Track', 'level': 'Beginner', 'count': 13},
            {'type': 'SKILL', 'category': 'Python Programing Track', 'level': 'Intermediate', 'count': 20},
            {'type': 'SKILL', 'category': 'Python Programing Track', 'level': 'Professional', 'count': 18}
        ],
        'careerTracks': [
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 1', 'count': 8},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 2', 'count': 26},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 3', 'count': 38},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 4', 'count': 34},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 5', 'count': 16},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 6', 'count': 40},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 7', 'count': 22},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 8', 'count': 10},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 9', 'count': 13},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 10', 'count': 10},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 1', 'count': 20},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 2', 'count': 15},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 3', 'count': 48},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 4', 'count': 9},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 5', 'count': 28},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 6', 'count': 39},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 7', 'count': 19},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 8', 'count': 5},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 9', 'count': 8},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 10', 'count': 5},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 1', 'count': 9},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 2', 'count': 9},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 3', 'count': 13},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 4', 'count': 14},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 5', 'count': 21},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 6', 'count': 37},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 7', 'count': 40},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 8', 'count': 4},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 9', 'count': 9},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 10', 'count': 10},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 1', 'count': 15},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 2', 'count': 30},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 3', 'count': 8},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 4', 'count': 32},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 5', 'count': 33},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 6', 'count': 35},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 7', 'count': 22},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 8', 'count': 22},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 9', 'count': 5},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 10', 'count': 1},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 1', 'count': 20},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 2', 'count': 25},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 3', 'count': 30},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 4', 'count': 14},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 5', 'count': 13},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 6', 'count': 5},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 7', 'count': 50},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 8', 'count': 11},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 9', 'count': 12},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 10', 'count': 3}
        ]
    },
    [ProSkillManagerType.ALL]: {
        'skillTracks': [
            {'type': 'SKILL', 'category': 'Linux Programming Track', 'level': 'Beginner', 'count': 48},
            {'type': 'SKILL', 'category': 'Linux Programming Track', 'level': 'Intermediate', 'count': 77},
            {'type': 'SKILL', 'category': 'Linux Programming Track', 'level': 'Professional', 'count': 13},
            {'type': 'SKILL', 'category': 'Java Script Programming Track', 'level': 'Beginner', 'count': 36},
            {'type': 'SKILL', 'category': 'Java Script Programming Track', 'level': 'Intermediate', 'count': 54},
            {'type': 'SKILL', 'category': 'Java Script Programming Track', 'level': 'Professional', 'count': 17},
            {'type': 'SKILL', 'category': 'SQL Programming Track', 'level': 'Beginner', 'count': 40},
            {'type': 'SKILL', 'category': 'SQL Programming Track', 'level': 'Intermediate', 'count': 65},
            {'type': 'SKILL', 'category': 'SQL Programming Track', 'level': 'Professional', 'count': 39},
            {'type': 'SKILL', 'category': 'Java Programming Track', 'level': 'Beginner', 'count': 46},
            {'type': 'SKILL', 'category': 'Java Programming Track', 'level': 'Intermediate', 'count': 65},
            {'type': 'SKILL', 'category': 'Java Programming Track', 'level': 'Professional', 'count': 28},
            {'type': 'SKILL', 'category': 'Python Programing Track', 'level': 'Beginner', 'count': 22},
            {'type': 'SKILL', 'category': 'Python Programing Track', 'level': 'Intermediate', 'count': 55},
            {'type': 'SKILL', 'category': 'Python Programing Track', 'level': 'Professional', 'count': 22}
        ],
        'careerTracks': [
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 1', 'count': 16},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 2', 'count': 52},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 3', 'count': 76},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 4', 'count': 68},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 5', 'count': 32},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 6', 'count': 80},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 7', 'count': 44},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 8', 'count': 20},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 9', 'count': 26},
            {'type': 'SKILL', 'category': 'Spring Boot Backend Track', 'level': 'Level 10', 'count': 20},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 1', 'count': 40},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 2', 'count': 30},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 3', 'count': 96},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 4', 'count': 18},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 5', 'count': 67},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 6', 'count': 67},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 7', 'count': 38},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 8', 'count': 10},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 9', 'count': 16},
            {'type': 'SKILL', 'category': 'AI Developer Track', 'level': 'Level 10', 'count': 10},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 1', 'count': 18},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 2', 'count': 18},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 3', 'count': 26},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 4', 'count': 28},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 5', 'count': 42},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 6', 'count': 74},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 7', 'count': 80},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 8', 'count': 8},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 9', 'count': 18},
            {'type': 'SKILL', 'category': 'Cyber Security Track', 'level': 'Level 10', 'count': 20},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 1', 'count': 30},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 2', 'count': 60},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 3', 'count': 16},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 4', 'count': 64},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 5', 'count': 66},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 6', 'count': 70},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 7', 'count': 44},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 8', 'count': 44},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 9', 'count': 10},
            {'type': 'SKILL', 'category': 'Javascript Frontend Track', 'level': 'Level 10', 'count': 2},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 1', 'count': 40},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 2', 'count': 50},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 3', 'count': 60},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 4', 'count': 54},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 5', 'count': 63},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 6', 'count': 10},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 7', 'count': 60},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 8', 'count': 16},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 9', 'count': 18},
            {'type': 'SKILL', 'category': 'Python Data Analyst Track', 'level': 'Level 10', 'count': 6}
        ]
    }
};
export const monitorAssessmentListData = [
    {
        'id': 0,
        'name': 'Sample Assessment',
        'title': 'Sample Assessment',
        'type': 'INTERNAL',
        'isEyeTracking': false,
        'isTabProctoring': false,
        'status': 'LIVE',
        'candidateSummary': {
            'total': 3,
            'preStart': 0,
            'inProgress': 0,
            'completed': 2,
            'stats': null
        },
        'totalTime': 10800,
        'startedAt': '2026-01-01 00:00:00',
        'endedAt': '2030-12-31 00:00:00',
        'createdAt': '2026-01-01 00:00:00',
        'sets': [
            {
                'trackId': 200,
                'trackTitle': 'Prompt Engineering for Developers',
                'trackLevelTitle': 'Beginner',
                'setCount': 4,
                "assessmentContentType": "AI_FLUENT"
            },
            {
                'trackId': 201,
                'trackTitle': 'JavaScript',
                'trackLevelTitle': 'Intermediate',
                'setCount': 1,
                "assessmentContentType": "CORE"
            }
        ],
        'noTimeLimit': false
    }
];
export const monitorCandidatesListData = {
    data: [
        {
            "name": "Gildong Hong 2",
            "email": "sample2@codepresso.kr",
            "userStatus": "NORMAL",
            "profileImageUrl": "https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg",
            "userUUID": "e9134e9d-d983-4933-9fdc-ee2141699648",
            "userId": 10795,
            "isScoreExposure": true,
            "isReportExposure": false,
            "reportUrl": null,
            "overallInfo": {
                "assessmentName": "Sample Assessment",
                "assessmentId": 0,
                "assessmentStatus": "LIVE",
                "lastRecord": "2026-01-31 06:12:28.784876",
                "integrityGrade": ViolationGradeType.CLEAN,
                "integrityReason": null,
                "status": "COMPLETED",
                "assessmentType": "EXTERNAL",
                "currentRank": 2,
                "totalRank": 3,
                "currentOverallScore": 58.5,
                "totalOverallScore": 100,
                "timeTaken": 8021,
                "totalTimeTaken": 10800,
                "skillAcquisitionRate": 56.1,
                "skillAcquisitionRateRank": 2,
                "totalSkillAcquisitionRateRank": 3
            },
            "trackResults": [
                {
                    "trackId": 572,
                    "testTemplateId": 0,
                    "trackName": "Prompt Engineering for Developers",
                    "currentTrackRank": 2,
                    "totalTrackRank": 3,
                    "currentTrackScore": 60.0,
                    "timeTaken": 3144,
                    "skillAcquisitionRate": 65.0,
                    "skillAcquisitionRateRank": 2,
                    "totalSkillAcquisitionRateRank": 3,
                    "trackLevelName": "Beginner",
                    "trackLevelId": 874
                },
                {
                    "trackId": 200001,
                    "testTemplateId": 1,
                    "trackName": "JavaScript",
                    "currentTrackRank": 2,
                    "totalTrackRank": 3,
                    "currentTrackScore": 57.0,
                    "timeTaken": 4877,
                    "skillAcquisitionRate": 51.1,
                    "skillAcquisitionRateRank": 2,
                    "totalSkillAcquisitionRateRank": 3,
                    "trackLevelName": "Intermediate",
                    "trackLevelId": 82
                }
            ]
        },
        {
            "name": "Gildong Hong 1",
            "email": "sample@codepresso.kr",
            "userStatus": "NORMAL",
            "profileImageUrl": "https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg",
            "userUUID": "f9dd5f8b-fe91-4fdd-bff4-0020647d42c0",
            "userId": 10794,
            "isScoreExposure": true,
            "isReportExposure": true,
            "reportUrl": null,
            "overallInfo": {
                "assessmentName": "Sample Assessment",
                "assessmentId": 0,
                "assessmentStatus": "LIVE",
                "lastRecord": "2026-01-31 01:21:57.704502",
                "integrityGrade": ViolationGradeType.CLEAN,
                "integrityReason": null,
                "status": "COMPLETED",
                "assessmentType": "EXTERNAL",
                "currentRank": 1,
                "totalRank": 3,
                "currentOverallScore": 88.5,
                "totalOverallScore": 100,
                "timeTaken": 6232,
                "totalTimeTaken": 10800,
                "skillAcquisitionRate": 87.8,
                "skillAcquisitionRateRank": 1,
                "totalSkillAcquisitionRateRank": 3
            },
            "trackResults": [
                {
                    "trackId": 572,
                    "testTemplateId": 0,
                    "trackName": "Prompt Engineering for Developers",
                    "currentTrackRank": 1,
                    "totalTrackRank": 3,
                    "currentTrackScore": 83.0,
                    "timeTaken": 2887,
                    "skillAcquisitionRate": 85.5,
                    "skillAcquisitionRateRank": 1,
                    "totalSkillAcquisitionRateRank": 3,
                    "trackLevelName": "Beginner",
                    "trackLevelId": 874
                },
                {
                    "trackId": 200001,
                    "testTemplateId": 1,
                    "trackName": "JavaScript",
                    "currentTrackRank": 1,
                    "totalTrackRank": 3,
                    "currentTrackScore": 94.0,
                    "timeTaken": 3345,
                    "skillAcquisitionRate": 89.1,
                    "skillAcquisitionRateRank": 1,
                    "totalSkillAcquisitionRateRank": 3,
                    "trackLevelName": "Intermediate",
                    "trackLevelId": 82
                }
            ]
        },
        {
            "name": "Gildong Hong 3",
            "email": "sample3@codepresso.kr",
            "userStatus": "NORMAL",
            "profileImageUrl": "https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg",
            "userUUID": "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
            "userId": 10796,
            "isScoreExposure": false,
            "isReportExposure": false,
            "reportUrl": null,
            "overallInfo": {
                "assessmentName": "Sample Assessment",
                "assessmentId": 0,
                "assessmentStatus": "LIVE",
                "lastRecord": "2026-02-02 01:30:47.817842",
                "integrityGrade": null,
                "integrityReason": null,
                "status": "READY",
                "assessmentType": "EXTERNAL",
                "currentRank": null,
                "totalRank": 3,
                "currentOverallScore": null,
                "totalOverallScore": 100,
                "timeTaken": null,
                "totalTimeTaken": 10800,
                "skillAcquisitionRate": null,
                "skillAcquisitionRateRank": null,
                "totalSkillAcquisitionRateRank": 3
            },
            "trackResults": [
                {
                    "trackId": 572,
                    "testTemplateId": 0,
                    "trackName": "Prompt Engineering for Developers",
                    "currentTrackRank": null,
                    "totalTrackRank": 3,
                    "currentTrackScore": null,
                    "timeTaken": 0,
                    "skillAcquisitionRate": null,
                    "skillAcquisitionRateRank": null,
                    "totalSkillAcquisitionRateRank": 3,
                    "trackLevelName": "Beginner",
                    "trackLevelId": 874
                },
                {
                    "trackId": 200001,
                    "testTemplateId": 1,
                    "trackName": "JavaScript",
                    "currentTrackRank": null,
                    "totalTrackRank": 3,
                    "currentTrackScore": null,
                    "timeTaken": 0,
                    "skillAcquisitionRate": null,
                    "skillAcquisitionRateRank": null,
                    "totalSkillAcquisitionRateRank": 3,
                    "trackLevelName": "Intermediate",
                    "trackLevelId": 82
                }
            ]
        }
    ],
    pageNumber: 1,
    last: true,
    totalElementCount: 3,
    sort: {
        empty: false,
        sorted: true,
        unsorted: false
    }
}

export const monitorCandidateSummary = {
    assessmentInfo: {
        status: 'LIVE',
        title: 'Sample Assessment',
        duration: 10800,
        startedAt: '2026-01-01 00:00:00',
        endedAt: '2030-12-31 00:00:00'
    },
    totalCandidates: 3,
    completedCandidates: 2,
    completedRate: 66.6,
    resultSummary: 'No data available for analysis.',
    top5ByScore: [
        {
            candidate: {
                uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                name: 'Gildong Hong 1',
                profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                userStatus: 'NORMAL'
            },
            rank: 1,
            value: 88.5,
            isReportExposure: true,
            reportUrl: null
        },
        {
            candidate: {
                uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                name: 'Gildong Hong 2',
                profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                userStatus: 'NORMAL'
            },
            rank: 2,
            value: 58.5,
            isReportExposure: false,
            reportUrl: null
        }
    ],
    top5ByRate: [
        {
            candidate: {
                uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                name: 'Gildong Hong 1',
                profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                userStatus: 'NORMAL'
            },
            rank: 1,
            value: 87.8,
            isReportExposure: true,
            reportUrl: null
        },
        {
            candidate: {
                uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                name: 'Gildong Hong 2',
                profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                userStatus: 'NORMAL'
            },
            rank: 2,
            value: 56.1,
            isReportExposure: false,
            reportUrl: null
        }
    ],
    bottom5ByScore: [
        {
            candidate: {
                uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                name: 'Gildong Hong 2',
                profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                userStatus: 'NORMAL'
            },
            rank: 2,
            value: 58.5,
            isReportExposure: false,
            reportUrl: null
        },
        {
            candidate: {
                uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                name: 'Gildong Hong 1',
                profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                userStatus: 'NORMAL'
            },
            rank: 1,
            value: 88.5,
            isReportExposure: true,
            reportUrl: null
        }
    ],
    bottom5ByRate: [
        {
            candidate: {
                uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                name: 'Gildong Hong 2',
                profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                userStatus: 'NORMAL'
            },
            rank: 2,
            value: 56.1,
            isReportExposure: false,
            reportUrl: null
        },
        {
            candidate: {
                uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                name: 'Gildong Hong 1',
                profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                userStatus: 'NORMAL'
            },
            rank: 1,
            value: 87.8,
            isReportExposure: true,
            reportUrl: null
        }
    ],
    trackResults: [
        {
            trackLevelName: 'Beginner',
            trackName: 'Prompt Engineering for Developers',
            trackId: 572,
            top5ByScore: [
                {
                    candidate: {
                        uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                        name: 'Gildong Hong 1',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 1,
                    value: 83.0,
                    isReportExposure: true,
                    reportUrl: null
                },
                {
                    candidate: {
                        uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                        name: 'Gildong Hong 2',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 2,
                    value: 60.0,
                    isReportExposure: false,
                    reportUrl: null
                }
            ],
            top5ByRate: [
                {
                    candidate: {
                        uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                        name: 'Gildong Hong 1',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 1,
                    value: 85.5,
                    isReportExposure: true,
                    reportUrl: null
                },
                {
                    candidate: {
                        uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                        name: 'Gildong Hong 2',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 2,
                    value: 65.0,
                    isReportExposure: false,
                    reportUrl: null
                }
            ],
            bottom5ByScore: [
                {
                    candidate: {
                        uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                        name: 'Gildong Hong 2',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 2,
                    value: 60.0,
                    isReportExposure: false,
                    reportUrl: null
                },
                {
                    candidate: {
                        uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                        name: 'Gildong Hong 1',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 1,
                    value: 83.0,
                    isReportExposure: true,
                    reportUrl: null
                }
            ],
            bottom5ByRate: [
                {
                    candidate: {
                        uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                        name: 'Gildong Hong 2',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 2,
                    value: 65.0,
                    isReportExposure: false,
                    reportUrl: null
                },
                {
                    candidate: {
                        uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                        name: 'Gildong Hong 1',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 1,
                    value: 85.5,
                    isReportExposure: true,
                    reportUrl: null
                }
            ]
        },
        {
            trackLevelName: 'Intermediate',
            trackName: 'JavaScript',
            trackId: 200001,
            top5ByScore: [
                {
                    candidate: {
                        uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                        name: 'Gildong Hong 1',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 1,
                    value: 94.0,
                    isReportExposure: true,
                    reportUrl: null
                },
                {
                    candidate: {
                        uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                        name: 'Gildong Hong 2',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 2,
                    value: 57.0,
                    isReportExposure: false,
                    reportUrl: null
                }
            ],
            top5ByRate: [
                {
                    candidate: {
                        uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                        name: 'Gildong Hong 1',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 1,
                    value: 89.1,
                    isReportExposure: true,
                    reportUrl: null
                },
                {
                    candidate: {
                        uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                        name: 'Gildong Hong 2',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 2,
                    value: 51.1,
                    isReportExposure: false,
                    reportUrl: null
                }
            ],
            bottom5ByScore: [
                {
                    candidate: {
                        uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                        name: 'Gildong Hong 2',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 2,
                    value: 57.0,
                    isReportExposure: false,
                    reportUrl: null
                },
                {
                    candidate: {
                        uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                        name: 'Gildong Hong 1',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 1,
                    value: 94.0,
                    isReportExposure: true,
                    reportUrl: null
                }
            ],
            bottom5ByRate: [
                {
                    candidate: {
                        uuid: 'e9134e9d-d983-4933-9fdc-ee2141699648',
                        name: 'Gildong Hong 2',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 2,
                    value: 51.1,
                    isReportExposure: false,
                    reportUrl: null
                },
                {
                    candidate: {
                        uuid: 'f9dd5f8b-fe91-4fdd-bff4-0020647d42c0',
                        name: 'Gildong Hong 1',
                        profileImageUrl: 'https://codepresso-global.s3.ap-northeast-2.amazonaws.com/user/profile/default.svg',
                        userStatus: 'NORMAL'
                    },
                    rank: 1,
                    value: 89.1,
                    isReportExposure: true,
                    reportUrl: null
                }
            ]
        }
    ]
};

